import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { EnterIcon } from "@radix-ui/react-icons";
import { PlusIcon, ThumbsUpIcon } from "lucide-react";
import { motion } from "motion/react";
import { Link } from "react-router-dom";

export function LineItemConfirmation() {
  return (
    <WidgetPage variant="centered">
      <motion.span
        initial={{ opacity: 0, scale: 0.9, y: 5, rotate: 10 }}
        animate={{ opacity: 1, scale: 1, rotate: 0, y: 0 }}
        exit={{
          opacity: 0,
          y: 20,
          transition: { duration: 0.25, ease: "easeIn" },
        }}
        transition={{ delay: 0.2, type: "spring" }}
        style={{ transformOrigin: "top left" }}
      >
        <ThumbsUpIcon className="text-success-foreground size-10 mx-auto" />
      </motion.span>

      <Header>
        <HeaderTitle>Article ajouté à votre demande de retour !</HeaderTitle>
        <HeaderDescription>
          Vous pouvez ajouter d'autres articles ou confirmer votre demande de
          retour.
        </HeaderDescription>
      </Header>

      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer
          layoutId="line-item-back-button"
          disableVariants={{ enter: true, exit: true }}
          layout="position"
        >
          <Link to="../..">
            <Button variant="secondary">
              <PlusIcon />
              Ajouter un autre article
            </Button>
          </Link>
        </AnimatedButtonContainer>
        <AnimatedButtonContainer
          layoutId="line-item-confirm-button"
          disableVariants={{ enter: true, exit: true }}
        >
          <Link to="../../../summary" relative="path">
            <Button>
              <EnterIcon />
              Récapitulatif
            </Button>
          </Link>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
